import { render, staticRenderFns } from "./PlaceDetails.vue?vue&type=template&id=16970644&"
import script from "./PlaceDetails.vue?vue&type=script&lang=js&"
export * from "./PlaceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports